@if (hasError) {
    <div class="lm-builder-info-container">
        <h1 class="heading">{{ errorHeader }}</h1>
        <p class="error-message">{{ errorMessage }}</p>
    </div>
} @else if (spec() && facade()) {
    <lm-builder-properties
        [spec]="spec()"
        [facade]="facade()"
        [canAdd]="canAdd()"
        [addTooltip]="addTooltip()"
        [dragTooltip]="dragTooltip()"
        [dropTargets]="dropTargets"
        (advancedSearch)="handleAdvancedSearch()"
        (addField)="handleAddField($event)">
    </lm-builder-properties>
    <lm-builder-preview
            [spec]="spec()"
            [listSpec]="listSpec()"
            [listTitleOverride]="listTitleOverride"
            [listUrlInfo]="listUrlInfo()"
            [lpl]="lpl()"
            [userFolderJson]="userFolderJson()"></lm-builder-preview>
}